import {
    intRangeToArray,
    limitChars,
    validateEmail,
    removeInvalidChars,
    checkNull,
    safeRedirect,
    strContains
} from '@/helpers'
import VueSimpleSuggest from 'vue-simple-suggest/dist/cjs'
import 'vue-simple-suggest/dist/styles.css'

export default {
    name: 'register-follow-up-pop-up',
    data() {
        return {
            cdn_url: window.APP_CONFIG.CDN_URL,
            icdn_url: window.APP_CONFIG.ICDN_URL,
            site_name: window.APP_CONFIG.DOMAIN_NAME,
            data_layer: window.dataLayer,
            is_dev: process.env.NODE_ENV !== 'production',
            open_change_email: false,
            open_register_with: null,
            display_terms: window.APP_CONFIG.PROFILE_CONFIRMATION,
            check_terms: {
                val: false,
                error_msg: '',
            },
            email: {
                val: '',
                error_msg: '',
                empty_error_msg: 'Enter valid Email',
                valid: false,
                is_loading: false,
                show_loading: false,
                suggestion: null
            },
            emails_fill: [],
            emails_suggest: [],
            email_ctr: '',
            email_ac: 'on',
            nick_name: {
                val: '',
                error_msg: '',
                empty_error_msg: 'Enter Nickname',
                min: 5,
                min_error_msg: 'Please enter at least 5 characters',
                alphanumeric_check: 'Nickname should not contain any space or special characters',
                max_number_char: 4,
                max_number_char_error: 'Maximum 4 number allowed',
                is_loading: false,
                show_loading: false
            },
            nick_name_limit: 16,
            nick_name_diff_limit: 16,
            name: {
                val: '',
                error_msg: '',
                empty_error_msg: 'Enter Your Name',
                min: 5,
                min_error_msg: 'Please enter at least 5 characters',
                alpha_check: 'Name should not contain any space, number or special character'
            },
            temp_nick_name: '',
            name_limit: 12,
            name_diff_limit: 12,
            age: {
                val: '',
                error_msg: ''
            },
            step_no: 1,
            country: '',
            countries: [],
            province: '',
            provinces: [],
            height: '',
            heights: [],
            weight: '',
            weights: [],
            body_type: '',
            body_types: [],
            hair_color: '',
            hair_colors: [],
            eye_color: '',
            eye_colors: [],
            desc: {
                val: '',
            },
            desc_limit: 500,
            desc_diff_limit: 500,
            link_email: '',
            link_spam: '',
            success_msg_step_three: '',
            btn_submit_disabled: false,
            is_new: true,
            token_resend: '',
            disable_resend: false,
            with_google_connect: window.APP_CONFIG.WITH_GOOGLE_CONNECT,
            with_yahoo_connect: window.APP_CONFIG.WITH_YAHOO_CONNECT,
            with_apple_connect: window.APP_CONFIG.WITH_APPLE_CONNECT || false,
            with_microsoft_connect: window.APP_CONFIG.WITH_MICROSOFT_CONNECT,
            sex_seeking_val: '',
            validatedEmail: null,
            should_autofil_gmail: true
        }
    },
    props: ['token', 'onboard', 'sex_seeking', 's_email', 's_nick_name', 's_age', 'from_api', 'from_smartlink', 'verify_only', 'provider',
            'provider_id', 'province_id', 'country_id', 'error_gmail_last_step', 'error_yahoo_last_step', 'error_apple_last_step',
            'error_microsoft_last_step', 'user_id', 's_token_resend', 'trial_ended'],
    methods: {
        hoverSuggest() {
            this.email.is_loading = true
            this.email.show_loading = true
        },
        selectedEmail(val) {
            if(val) {
                this.email.val = val
                this.checkEmail()
            }
        },
        redirectToBlockRegister(res) {
            let name = 'blocked-register';
            if (res.oauth) {
                name = 'failed-oauth'
            }
            this.$router.push({ name, query:
                {
                    redirect: res.redirect || null,
                    hash: res.hash || null
                }
            })
        },
        checkEmail(onBlur) {
            this.email.is_loading = true
            this.email.show_loading = true
            const emoji_range = [
                '\u00a9',
                '\u00ae',
                '[\u2000-\u3300]',
                '\ud83c[\ud000-\udfff]',
                '\ud83d[\ud000-\udfff]',
                '\ud83e[\ud000-\udfff]',
            ]
            this.email.val = removeInvalidChars(this.email.val, emoji_range)
            let s_email = this.email.val
            let email_parts = s_email.split('@')
            if (s_email.substr(s_email.length-6) === '@gmail' && this.should_autofil_gmail || checkNull(email_parts[1]) && email_parts[1].substr(0,9) === 'gmail.com') {
                this.email.val = email_parts[0] + '@gmail.com'
                this.should_autofil_gmail = false
            }
            if(s_email.substr(s_email.length-5) === '@gmai') this.should_autofil_gmail = true
            if(validateEmail(this.email.val)) {
                let registerWithProvider = null;
                if(onBlur) {
                    registerWithProvider = this.checkEmailProvider();
                    if(!registerWithProvider && this.validatedEmail !== this.email.val) {
                        this.validateEmailAddress();
                    } else {
                        this.email.error_msg = ''
                        this.email.is_loading = false
                        this.email.show_loading = false
                    }
                } else {
                    this.email.error_msg = ''
                    this.email.is_loading = false
                    this.email.show_loading = false
                }
            } else {
                this.email.show_loading = false
                this.email.error_msg = this.email.empty_error_msg
            }
        },
        checkEmailProvider() {
            if (!this.provider && !this.verify_only) {
                const whitelistedProviders = [
                    /@yahoo\./,
                    /@Ymail\./,
                    /@ymail\./,
                    /@myyahoo\./,
                    /@rocketmail\./,
                    /@Y7mail\./,
                    /@y7mail\./,
                ];
                if (this.with_yahoo_connect && strContains(this.email.val, whitelistedProviders)) {
                    return this.registerWith('yahoo');
                }
                if (this.with_apple_connect && /@(icloud|me|mac)\.com$/.test(this.email.val)) {
                    return this.registerWith('apple');
                }
            }
            return null;
        },
        registerWith(provider) {
            switch(provider) {
                case 'yahoo':
                case 'apple':
                    this.open_register_with = provider;
                    break;
                default:
                    this.open_register_with = null;
            }
            return this.open_register_with;
        },
        cancelRegistrationWithOauth() {
            this.open_register_with = null;
        },
        hidelist() {
            //added this because of bug on vue simple suggest mobile
            this.$nextTick(() => {
                if(checkNull(this.$refs['suggest-email'])) this.$refs['suggest-email'].hideList()
            })
        },
        limitChars(e, key) {
            if(this[`${key}_limit`]) limitChars(this, (e ? e : key), `${key}_limit`, `${key}_diff_limit`)
        },
        validateInput(e, key) {
            this[key].error_msg = ''
            let s_value = e ? e.target.value : this[key].val
            let error_msg = ''

            if(this[`${key}_limit`])
                limitChars(this, (e ? e : key), `${key}_limit`, `${key}_diff_limit`)

            if(!s_value && this[key]['empty_error_msg']) {
                error_msg = this[key]['empty_error_msg']
            }

            if(s_value) {
                if(key == 'nick_name') this[key]['is_loading'] = true

                if(this[key]['min'] && s_value.length < this[key]['min'])
                    error_msg = this[key]['min_error_msg']

                if(this[key]['alphanumeric_check'] && !s_value.match(/^[a-zA-Z0-9-_]+$/))
                    error_msg = this[key]['alphanumeric_check']

                if(this[key]['alpha_check'] && !s_value.match(/^[a-zA-Z ]+$/))
                    error_msg = this[key]['alpha_check']

                if(this[key]['max_number_char'] &&
                    s_value.replace(/[^0-9]/g, '').length > this[key]['max_number_char'])
                    error_msg = this[key]['max_number_char_error']
            }

            this[key].error_msg = error_msg
        },
        replaceEmailWithSuggestion() {
            if(this.email.suggestion) {
                this.email.error_msg = null;
                this.email.val = this.email.suggestion;
            }
            this.email.suggestion = null;
        },
        validateEmailAddress() {
            if(this.email.val && !this.email.error_msg) {
                this.email.is_loading = true
                this.email.show_loading = true
                this.validatedEmail = this.email.val;
                this.$store.dispatch('auth/validateEmail', {email: this.email.val})
                    .then(res => {
                        this.email.is_loading = false
                        this.email.show_loading = false
                        this.email.suggestion = null;
                        if(!res.data.success) {
                            let suggestions = res.data?.suggestions || null;
                            if (suggestions !== null && suggestions.email) {
                                this.email.val = suggestions.email;
                            } else {
                                this.email.error_msg = res.data?.errors?.email[0] || 'Email not available';
                            }
                        }
                    }, res => {
                        this.email.is_loading = false
                        this.email.show_loading = false
                        console.log(res)
                    })
            } else {
                this.email.is_loading = false
                this.email.show_loading = false
            }
        },
        checkUniqueEmail() {
            if(this.email.val && !this.email.error_msg) {
                this.email.is_loading = true
                this.email.show_loading = true
                this.$store.dispatch('auth/checkUniqueEmail', {email: this.email.val})
                    .then(res => {
                        this.email.is_loading = false
                        this.email.show_loading = false
                        let s_res = checkNull(res.data.response) && res.data.response.toLowerCase()
                        if(s_res != 'unique') {
                            this.email.error_msg = 'Email not available'
                        }
                    }, res => {
                        this.email.is_loading = false
                        this.email.show_loading = false
                        console.log(res)
                    })
            } else {
                this.email.is_loading = false
                this.email.show_loading = false
            }
        },
        checkUniqueNickname() {
            if(this.nick_name.val != this.temp_nick_name){
                this.temp_nick_name = this.nick_name.val
                this.nick_name.is_loading = true
                this.nick_name.show_loading = true
                let payload = {nick_name: this.nick_name.val}
                if(this.user_id) payload['user_id'] = this.user_id
                this.$store.dispatch('auth/checkUniqueNickname', payload)
                    .then(res => {
                        this.nick_name.is_loading = false
                        this.nick_name.show_loading = false
                        let s_res = checkNull(res.data.response) && res.data.response.toLowerCase()
                        if(s_res == 'unique') {
                            if(!this.nick_name.error_msg) this.nick_name.error_msg = ''
                        } else {
                            this.nick_name.error_msg = 'Nickname not available'
                        }
                    }, res => {
                        this.nick_name.is_loading = false
                        this.nick_name.show_loading = false
                        console.log(res)
                    })
            } else {
                this.nick_name.is_loading = false
                this.nick_name.show_loading = false
            }
        },
        submitStepOne() {
            if(this.display_terms && !this.check_terms.val) {
                this.check_terms.error_msg = 'Please accept the terms and conditions to continue'
                return;
            }
            this.check_terms.error_msg = ''
            if(!this.allowFirstStep) {
                if(!this.is_new) {
                    this.step_no = 2
                } else {
                    this.submitStepTwo()
                }
            }
        },
        submitStepTwo() {
            if (this.checkEmailProvider()) {
                return;
            }

            if (this.from_smartlink) {
                this.$router.push({name: 'user-activate-profile', params: {token: this.token} });
                return;
            }

            this.btn_submit_disabled = true
            let params = {
                nick_name: this.nick_name.val,
                age: this.age.val,
                province_id:this.province,
                provider:this.provider,
                provider_id:this.provider_id,
            }

            if(this.is_new) {
                params = Object.assign(params, {
                    sex_seeking:this.sex_seeking_val,
                    email:this.email.val,
                })
            } else {
                params = Object.assign(params, {
                    name: this.name.val,
                    body_type_id: this.body_type,
                    country_id: this.country,
                    description: this.desc.val,
                    eye_color_id: this.eye_color,
                    hair_color_id: this.hair_color,
                    height: this.height,
                    weight: this.weight,
                })
            }

            if(this.verify_only) params['id'] = this.user_id

            this.$store.dispatch('auth/registerFinish', { token: this.token, params }).then(res => {
                if(res.data && res.data.events) {
                    this.$store.dispatch('pub/allowLeave', true)
                    this.pushDataLayer(res)
                }
                if (res.data && res.data.trial && res.data.token) {
                    this.$store.dispatch('cookies/setORegister', null)
                    this.startTrial(res.data.token, res.data.trial, res.data.key)
                } else if (this.verify_only) {
                    this.$store.commit('auth/setAuth', res)
                    this.$store.dispatch('auth/getUser', {delay_webpush: true})
                    this.$store.dispatch('profile/populateProfiles')
                    this.$store.dispatch('message/getIcebreakers')
                    this.$store.dispatch('pub/getFormValues')
                    this.$router.push({name: 'user-activate-profile', params: {token: this.token} })
                } else {
                    this.$store.dispatch('cookies/setORegister', null)
                    this.logRegisterEvent(res)
                    if(this.provider && res.data.auto_login_url) {
                        safeRedirect(res.data.auto_login_url)
                        this.$store.commit('auth/setLoggedInTime', Date.now())
                    } else {
                        this.btn_submit_disabled = false
                        this.link_email = res.data.inbox_url
                        this.link_spam = res.data.spambox_url
                        this.step_no = 3
                        this.$store.dispatch('cookies/setOUser', {id: res.data.user_id})
                        if(this.is_new) this.token_resend = res.data.key
                    }
                }
            }, (res) => {
                this.btn_submit_disabled = false
                if(res.data.error_registration) {
                    this.redirectToBlockRegister(res.data.error_registration)
                } else {
                    this.step_no = 1
                    if (res.data.email) this.email.error_msg = res.data.email[0]
                    if (res.data.nick_name) this.nick_name.error_msg = 'Nickname not available'
                }
                console.log(res)
            })
        },
        startTrial(token, trial, key) {
            this.$store.dispatch('trial/start', {
                token, trial, key,
                callback: (params) => {
                    console.log('redirecting to activate profile', params)
                    this.$router.push({ name: 'user-activate-profile', params })
                }
            })
            this.$store.dispatch('profile/populateProfiles')
            this.$store.dispatch('message/getIcebreakers')
            this.$store.dispatch('pub/getFormValues')
            this.$router.push({name: 'user-home'})
        },
        pushDataLayer(res) {
            if(res.data && res.data.events && checkNull(this.data_layer)) {
                const tracking_data = res.data.tracking_data || {};
                if(res.data.events.includes('Registration_ok')) {
                    this.data_layer.push({
                        'event': 'Registration_ok',
                        'formId': 'RegisterForm',
                        'user_id': res.data.user_id,
                         ...tracking_data
                    })
                }
                if(res.data.events.includes('email_conf')) {
                    this.data_layer.push({
                        'event': 'email_conf',
                        'formId': 'VerifyEmail',
                        'user_id': res.data.user_id,
                        ...tracking_data
                    })
                }
            }
        },
        logRegisterEvent(params, res) {
            let user_hash = window.location.host + '_' + params.nick_name
            if(typeof Startup !== 'undefined') {
                Startup.Store('userHash', user_hash)
                for(let key in params) {
                    Startup.Store(key, params[key])
                }

                Startup.AfterResult((res) => {
                    console.log(res)
                    res['action_name'] = 'registration_success'
                    res['email'] = params['email']
                    this.saveIpqsResults(res)
                })

                Startup.AfterFailure((res) => {
                    console.log('after failure')
                    console.log(res)
                    res['action_name'] = 'registration_fail'
                    res['email'] = params['email']
                    this.saveIpqsResults(res)
                })

                Startup.Resume()
            }
        },
        saveIpqsResults(res) {
            return this.$store.dispatch('pub/saveIpqsResults', res)
        },
        linkToEmail() {
            if(this.link_email) {
                window.open(this.link_email, '_blank')
            }
        },
        linkToSpam() {
            if(this.link_spam) {
                window.open(this.link_spam, '_blank')
            }
        },
        reSendConfirmEmail() {
            this.disable_resend = true
            let token = (this.is_new) ? this.token_resend : this.token
            this.success_msg_step_three = ''
            this.$store.dispatch('auth/resendConfirmEmail', {
                token,
                params: {
                    email: this.email.val
                }
            }).then(res => {
                this.success_msg_step_three = 'Your activation mail has been sent'
            }, res => {
                if(res.data.email) this.email.error_msg = res.data.email[0]
                console.log(res)
            })
        },
        setFormValues(values) {
            this.checkQueries()
            this.country = values['registration_defaults']['country_id']
            this.countries = values['countries']
            this.province = (typeof this.province_id != 'undefined') ? this.province_id : values['registration_defaults']['province_id']
            this.provinces = values['provinces']
            this.height = values['registration_defaults']['height']
            this.heights = values['heights']
            this.weight = values['registration_defaults']['weight']
            this.weights = values['weights']
            this.body_type = values['registration_defaults']['body_type_id']
            this.body_types = values['body_types']
            this.hair_color = values['registration_defaults']['hair_color_id']
            this.hair_colors = values['hair_colors']
            this.eye_color = values['registration_defaults']['eye_color_id']
            this.eye_colors = values['eye_colors']
        },
        generateNickName() {
            let sex = (this.is_new) ? this.sex_seeking_val.split('-')[0] : 'male'
            this.$store.dispatch('auth/getRandomNickName', {sex})
                .then(res => {
                    this.nick_name.is_loading, this.nick_name.show_loading = true
                    if(checkNull(res.data.response)) {
                        this.nick_name.val = res.data.response
                        this.validateInput(null, 'nick_name')
                        this.checkUniqueNickname()
                    }
                }, res => {
                    console.log(res)
                })
        },
        checkToken(token) {
            this.$store.dispatch('auth/getPreActivatedUser', {token})
            .then(res => {
                if(this.from_api && checkNull(res.data.trial)) {
                    this.startTrial(res.data.token, res.data.trial, token)
                }

                if(checkNull(res.data.response) && res.data.response == 'Unknown') {
                    this.$router.push({ name: 'home' })
                } else {
                    if(this.step_no != 3) this.checkValues(res)
                }
            },res=> {
                this.$router.push({ name: 'home' })
            })
        },
        checkValues(res) {
            if(checkNull(res.data.email)) {
                this.email.val = res.data.email
                let nick_name = this.s_nick_name ? this.s_nick_name : res.data.email.split('@')[0].replace(/\s+/g, '').replace(/[^\w]+/g, '').replace(/[_-]/g, '')
                let payload = {nick_name}
                if(this.user_id) payload['user_id'] = this.user_id
                this.$store.dispatch('auth/checkUniqueNickname', payload)
                    .then(res => {
                        if(checkNull(res.data.response) && res.data.response.toLowerCase() == 'unique') {
                            this.nick_name.val = nick_name
                            this.validateInput(null, 'nick_name')
                        }
                        this.nick_name.is_loading = false
                        this.nick_name.show_loading = false
                    }, res => {
                        console.log(res)
                        this.nick_name.is_loading = false
                        this.nick_name.show_loading = false
                    })
            } else {
                this.$router.push({ name: 'home' })
            }
        },
        checkQueries() {
            if(this.is_new) {
                if(checkNull(this.country_id) && this.country_id != this.formValues['registration_defaults']['country_id']) {
                    this.$store.dispatch('pub/getProvinces', {country_id: this.country_id})
                        .then(res => {
                            this.validateQueries(res.data.data)
                        }, res => {
                            console.log(res)
                            this.$router.push({ name: 'home' })
                        })
                } else {
                    this.validateQueries(this.formValues['provinces'])
                }
            }
        },
        validateQueries(provinces) {
            let b_sex_seeking = this.formValues['sex_seeking'].find((val) => val.value == this.sex_seeking_val )
            let o_province = provinces.find((val) => val.id == this.province_id )
            if(!this.from_api && !this.verify_only) {
                if(!checkNull(b_sex_seeking) || !checkNull(o_province) )
                    this.$router.push({ name: 'home' })
            }
        },
        changeEmail() {
            this.open_change_email = !this.open_change_email
            this.$nextTick(() => {
                if(typeof this.$refs['follow-up-con'] != 'undefined')
                    this.$refs['follow-up-con'].parentElement.scrollTop = this.$refs['follow-up-con'].parentElement.scrollHeight
            })
        },
        redirectOauth(provider) {
            let params = {};
            ['nick_name', 'email', 'age'].map(key => {
                if(this[key].val) {
                    params[key] = this[key].val
                }
            })
            let sd_config = this.$store.getters['cookies/getSdConfig'];
            params = {...params, ...sd_config}

            const queryString = Object.keys(params).map(function(key) {
                return key + '=' + params[key]
            }).join('&');
            safeRedirect(`${window.location.origin}/oauth/redirect/${provider}` + (queryString.length ? '?' + queryString : ''))
        },
        recaptcha(user_id, cb) {
            if(this.is_dev) {
                cb()
            } else {
                this.$recaptcha('recaptcha_register').then((token) => {
                    this.saveIpqsResults({
                        action_name: 'recaptcha',
                        page: 'register',
                        user_id,
                        token
                    }).then( cb )
                }, () => {
                    console.log('failed recaptcha')
                    cb()
                })
            }
        },
        goToLastStep() {
            this.step_no = 3
            this.email.val = this.s_email
            this.$store.dispatch('pub/getInboxSpamUrl', {email: this.email.val}).then(res => {
                this.link_email = res.data.inbox_url
                this.link_spam = res.data.spam_link
            }, res => {
                console.log(res)
            })
            this.token_resend = this.s_token_resend
            this.$store.dispatch('cookies/setOUser', {id: this.user_id})
        },
        capitalize(s) {
            if (typeof s !== 'string') return ''
            return s.charAt(0).toUpperCase() + s.slice(1)
        }
    },
    computed: {
        ages() {
            return intRangeToArray(18, 99)
        },
        allowFirstStep() {
            let allow = (this.nick_name.val && !this.nick_name.error_msg)

            if(this.is_new) {
                if(allow && this.email.val && !this.email.error_msg && !this.email.is_loading)
                    return false
            } else {
                if(allow && this.name.val && !this.name.error_msg)
                    return false
            }

            return true
        },
        showDesktop() {
            return this.$root.$children[0].width > 1199
        },
        emailPlaceholder() {
            return this.showDesktop ? this.$t('It will not be shared') : this.$t('It will never be shared. 100% Privacy')
        },
        formValues() {
            return this.$store.getters['pub/formValues']
        },
        emailVal() {
            return this.email.val
        },
        routeFrom() {
            return this.$store.getters['pub/routeFrom']
        },
        rg_text_1() {
            return this.showDesktop ?  'Complete your profile in a minute and start contacting people' : 'Complete your profile'
        },
        rg_text_2() {
            return 'CONTINUE'
        },
        langIsGerman() {
            return Vue.i18n.locale().toLowerCase() == 'de'
        },
        oauthProviders() {
            let oauthProviders = [];
            if(this.with_google_connect) {
                oauthProviders.push('google');
            }
            /*
            if(this.with_yahoo_connect) {
                oauthProviders.push('yahoo');
            }
            if(this.with_apple_connect) {
                oauthProviders.push('apple');
            }
            */
            if(this.with_microsoft_connect) {
                oauthProviders.push('microsoft');
            }
            return oauthProviders;
        }
    },
    created() {
        this.sex_seeking_val = this.sex_seeking
        this.$store.dispatch('cookies/setOUser', null)
        if(!this.from_api && !this.trial_ended) {
            this.$store.dispatch('cookies/setORegister', {
                sex_seeking: this.sex_seeking_val,
                province_id: this.province_id,
                country_id: this.country_id,
            })
        }
        if(this.error_gmail_last_step || this.from_api || this.trial_ended) {
            //console.log(this.routeFrom)
            this.goToLastStep()
            if (checkNull(this.s_token_resend)) this.checkToken(this.s_token_resend)
        } else if (!this.from_smartlink) {
            if(checkNull(this.token)) {
                 this.is_new = false
                 this.checkToken(this.token)
            }
            if(this.formValues) this.setFormValues(this.formValues)
            if(this.s_nick_name) {
                this.nick_name.val = this.s_nick_name
                this.checkUniqueNickname()
            } else {
                this.generateNickName()
            }
            if(this.s_email) {
                this.email.val = this.s_email
                this.checkEmail()
            }
            if(this.s_age) this.age.val = this.s_age
            this.$store.dispatch('pub/getEmailAutoFillDomains', {country_id: this.country_id})
                .then(res => {
                    this.emails_fill = res.data.domains
                }, res => {
                    console.log(res)
                })
        } else {
            if(this.formValues) this.setFormValues(this.formValues)
            this.nick_name.val = this.s_nick_name
            this.email.val = this.s_email
            this.age.val = this.s_age
        }
    },
    mounted() {
        if (!this.age.val) this.age.val = 18
        if (typeof Startup !== 'undefined') {
            Startup.Pause()
            Startup.Init()
        }
    },
    watch: {
        formValues(values) {
            if(values && !this.error_gmail_last_step) this.setFormValues(values)
        },
        emailVal(val) {
            this.email_ac = 'on'
            if(checkNull(val) && val.indexOf("@") != -1) {
                this.email_ac = 'off'
                if(this.email_ctr != val.split('@')[0]) {
                    this.emails_suggest = []
                    if(this.email.suggestion) {
                        this.emails_suggest.push(this.email.suggestion)
                    }
                    this.email_ctr = val.split('@')[0]
                    this.emails_fill.forEach(val => {
                        let sval = `${this.email_ctr}@${val}`
                        if(this.emails_suggest.indexOf(sval) == -1)
                            this.emails_suggest.push(sval)
                    })
                }
            }
        }
    },
    components: {
        VueSimpleSuggest
    }
}
